import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
import { getQueryString } from '@/utils/common'
export const queryHistoryPointDetail = async (params: object) => {
  return await GET({
    url: Api.queryHistoryPointDetail,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      cityId: getQueryString('cityId'),
      token: getQueryString('token'),
      ...params
    },
    showError: false
  })
}
